module.exports = __webpack_public_path__ + "d12.no2.e529880c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d12.no2.jpg
// module id = 2THQ
// module chunks = 0